<!--
This file is part of the project: "Digiziege"
An app for animal-welfare-oriented goat husbandry and contactless weight estimation.
GitLab: https://gitlab.rlp.net/proj-wise2526-digiziege/digiziege

Copyright (c) 2026 Digiziege Team TH-Bingen

Description:
Companion app for welfare-oriented goat husbandry featuring contactless weight estimation via camera,
master data management and health tracking.
Built as a PWA with a local-first approach to ensure data privacy.

LICENSE INFORMATION:
This program is free software: you can redistribute it and/or modify it under the terms of the
GNU Affero General Public License as published by the Free Software Foundation,
either version 3 of the License, or (at your option) any later version.

This program is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY;
without even the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.
See the GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License along with this program.
If not, see <https://www.gnu.org/licenses/>.
-->

<template>
  <button 
    @click="$emit('trigger-refresh')"
    :disabled="loading"
    class="flex items-center justify-center bg-[var(--color-primary-200)] rounded-lg border border-[var(--color-primary-400)] h-[42px] w-[42px] shrink-0 cursor-pointer transition-all duration-200 hover:bg-[var(--color-primary-300)] active:bg-[var(--color-primary-400)] disabled:opacity-70 disabled:cursor-not-allowed text-[var(--color-primary-600)] hover:text-[var(--color-primary-900)]"
    :title="$t('common.refresh')"
  >
    <RefreshCw 
      class="w-5 h-5" 
      :class="{'animate-spin': loading}" 
    />
  </button>
</template>

<script setup>
import { RefreshCw } from 'lucide-vue-next';

defineProps({
  loading: {
    type: Boolean,
    default: false
  }
});

defineEmits(['trigger-refresh']);
</script>